




















































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import FlightProvider from "@/store/entities/flight/flightProvider";
import AirlineCompany from "@/store/entities/flight/airlineCompany";
import Currency from "@/store/entities/currency";
import Aircraft from "@/store/entities/flight/aircraft";
import moment from "moment";
import FlightInput from "@/store/entities/flight/flightInput";
@Component({})
export default class UpdateFlightInformationModal extends Vue {
  dialog: boolean = true;
  departureDate: Date = null;
  passport: Date = null;
  birthday: Date = null;
  flightProviders: FlightProvider[] = [];
  airlineCompanies: AirlineCompany[] = [];
  currencies: Currency[] = [];
  aircrafts: Aircraft[] = [];
  departureMenu: boolean = false;
  flightInput: FlightInput = new FlightInput();
 
  updateInfo(e) {
    e.preventDefault();
    this.$emit("flightInfo", this.flightInput);
    this.closeDialog();
  }

  get getDepartureDate() {
    return this.flightInput.departureDate
      ? moment(this.flightInput.departureDate).format("DD-MM-yyyy")
      : "";
  }

  created() {
    this.flightInput.isActive=false;
    this.getFlightProviders();
    this.getAirlineCompanies();
    this.getCurrencies();
  }

  async getFlightProviders() {
    await this.$store.dispatch({
      type: "flightProvider/getFlightProviders",
    });

    this.flightProviders = this.$store.state.flightProvider.list;
  }

  async getAirlineCompanies() {
    await this.$store.dispatch({
      type: "airlineCompany/getAirlineCompanies",
    });

    this.airlineCompanies = this.$store.state.airlineCompany.list;
  }

  async getCurrencies() {
    await this.$store.dispatch({
      type: "currency/getCurrencies",
    });

    this.currencies = this.$store.state.currency.list;
  }
  closeDialog() {
    this.$emit("closed");
  }
}
